import { useCallback, useEffect, useState } from 'react'
import { SocioeducationMeasureType } from 'types/socioeducation-measure.type'
import client from 'services/client'
import { BaseData } from 'types/base.type'

export const useMeioAberto = (id?: number | string | null) => {
  const [meioAberto, setMeioAberto] = useState<SocioeducationMeasureType | null>(null)

  const handleBuscarPorId = useCallback(async () => {
    if (id) {
      const url = `/meio-aberto/${id}`
      await client.get<BaseData<SocioeducationMeasureType>>(url).then((response) => {
        if (response.data) {
          setMeioAberto(response.data)
        }
      })
    }
  }, [id])

  useEffect(() => {
    handleBuscarPorId()
  }, [handleBuscarPorId])

  return {
    meioAberto,
    handleBuscarPorId,
  }
}
